import * as React from 'react';

import styles from './Schema.scss';
import { SchemaLocale } from './schema.locale';

interface SchemaProps {
  locale: SchemaLocale;
}

const Schema: React.SFC<SchemaProps> = ({ locale }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 373 364" fill="none">
    <path
      d="M93.97 319.39h185.87l70.84-174.01-165.5-99.47L23.43 150.27z"
      className={styles.outerPentagon}
    />
    <path
      d="M100.08 311.39h173L339 149.44 183.97 56.86 34.43 153.99z"
      className={styles.innerPentagon}
    />
    <path
      d={`M185 124l-1-77M94 316l51.22-65.75M280 317l-53.65-66.39m24.8-68.61L350
          147m-326 2l95 33m66.3-58l66.15 58-25.35 67.85h-81.75L119 182z`}
      className={styles.spider}
    />
    <g className={styles.outerCircles}>
      <circle cx="184" cy="47" r="8" />
      <circle cx="350" cy="147" r="8" />
      <circle cx="280" cy="317" r="8" />
      <circle cx="94" cy="317" r="8" />
      <circle cx="24" cy="149" r="8" />
    </g>
    <g className={styles.innerCircles}>
      <circle cx="184" cy="47" r="5" />
      <circle cx="350" cy="147" r="5" />
      <circle cx="280" cy="317" r="5" />
      <circle cx="94" cy="317" r="5" />
      <circle cx="24" cy="149" r="5" />
    </g>
    <text x="145.3" y="196" className={styles.centerText}>
      Peering.cz
    </text>
    <text x="184" y="18" className={styles.text}>
      CDN
    </text>
    <text x="350" y="182" className={styles.text}>
      DNS
    </text>
    <text x="280" y="352" className={styles.text}>
      {locale.content}
    </text>
    <text x="94" y="352" className={styles.text}>
      ISP
    </text>
    <text x="24" y="182" className={styles.text}>
      {locale.telco}
    </text>
  </svg>
);
export default Schema;



// WEBPACK FOOTER //
// /www/client/src/components/ServicesPricingPage/Schema/Schema.tsx